import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_SMS_TEMPLATE_LIST_REQUEST = 'FETCH_SMS_TEMPLATE_LIST_REQUEST';
export const FETCH_SMS_TEMPLATE_LIST_SUCCESS = 'FETCH_SMS_TEMPLATE_LIST_SUCCESS';
export const FETCH_SMS_TEMPLATE_LIST_FAILURE = 'FETCH_SMS_TEMPLATE_LIST_FAILURE';

export const EDIT_SMS_TEMPLATE_SEQUENCE_REQUEST = 'EDIT_SMS_TEMPLATE_SEQUENCE_REQUEST';
export const EDIT_SMS_TEMPLATE_SEQUENCE_FAILURE = 'EDIT_SMS_TEMPLATE_SEQUENCE_FAILURE';
export const EDIT_SMS_TEMPLATE_SEQUENCE_SUCCESS = 'EDIT_SMS_TEMPLATE_SEQUENCE_SUCCESS';

export const FETCH_SMS_TEMPLATE_REQUEST = 'FETCH_SMS_TEMPLATE_REQUEST';
export const FETCH_SMS_TEMPLATE_SUCCESS = 'FETCH_SMS_TEMPLATE_SUCCESS';
export const FETCH_SMS_TEMPLATE_FAILURE = 'FETCH_SMS_TEMPLATE_FAILURE';

export const EDIT_SMS_TEMPLATE_REQUEST = 'EDIT_SMS_TEMPLATE_REQUEST';
export const EDIT_SMS_TEMPLATE_SUCCESS = 'EDIT_SMS_TEMPLATE_SUCCESS';
export const EDIT_SMS_TEMPLATE_FAILURE = 'EDIT_SMS_TEMPLATE_FAILURE';

export const CREATE_SMS_TEMPLATE_REQUEST = 'CREATE_SMS_TEMPLATE_REQUEST';
export const CREATE_SMS_TEMPLATE_SUCCESS = 'CREATE_SMS_TEMPLATE_SUCCESS';
export const CREATE_SMS_TEMPLATE_FAILURE = 'CREATE_SMS_TEMPLATE_FAILURE';

const baseURL = 'agencies/config/templates/sms';

export const fetchSMSTemplateList = () => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    types: [FETCH_SMS_TEMPLATE_LIST_REQUEST, FETCH_SMS_TEMPLATE_LIST_SUCCESS, FETCH_SMS_TEMPLATE_LIST_FAILURE],
  },
});

export const editSMSTemplateSequence = (sequence: number[]) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/sequence`,
    method: 'put',
    authenticated: true,
    body: { sequence },
    types: [EDIT_SMS_TEMPLATE_SEQUENCE_REQUEST, EDIT_SMS_TEMPLATE_SEQUENCE_SUCCESS, EDIT_SMS_TEMPLATE_SEQUENCE_FAILURE],
  },
});

export const fetchSMSTemplate = (smsTemplateId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${smsTemplateId}`,
    method: 'get',
    authenticated: true,
    types: [FETCH_SMS_TEMPLATE_REQUEST, FETCH_SMS_TEMPLATE_SUCCESS, FETCH_SMS_TEMPLATE_FAILURE],
  },
});

export const editSMSTemplate = (smsTemplateId: number, smsTemplateData: ISMSTemplateRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${smsTemplateId}`,
    method: 'put',
    body: smsTemplateData,
    authenticated: true,
    types: [EDIT_SMS_TEMPLATE_REQUEST, EDIT_SMS_TEMPLATE_SUCCESS, EDIT_SMS_TEMPLATE_FAILURE],
  },
});

export const createSMSTemplate = (data: ISMSTemplateCreateRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    body: data,
    authenticated: true,
    types: [CREATE_SMS_TEMPLATE_REQUEST, CREATE_SMS_TEMPLATE_SUCCESS, CREATE_SMS_TEMPLATE_FAILURE],
  },
});
